var $ = require('jquery');
window.xx=[];
/**
 *
 * @constructor
 */
var MapRenderer = module.exports = function() {

};

/**
 *
 * @param element
 */
MapRenderer.prototype.decorate = function(element) {
    this.element = (element instanceof $) ? element : $(element);

    this.setData();
    this.initialize();
};

MapRenderer.prototype.setData = function() {
    this.lat = this.element.data('lat');
    this.lng = this.element.data('lng');
    this.href = this.element.data('href');
};

MapRenderer.prototype.initialize = function() {
    var location = new google.maps.LatLng(this.lat, this.lng);

    var mapOptions = {
        zoom: 14,
        center: location,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        scrollwheel: false
    };
    var theMap = new google.maps.Map(this.element[0], mapOptions);

    window.xx.push(theMap);

    var marker = new google.maps.Marker({
        map: theMap,
        draggable: false,
        position: location,
        visible: true,
        icon: '/img/marker.png'
    });

    if (typeof(this.href) != 'undefined') {
        this.setMarkerClickEvent(marker);
    }

    this.setScrollEventListener(theMap);

    this.map = theMap;
};

/**
 *
 * @param marker {google.maps.Marker}
 */
MapRenderer.prototype.setMarkerClickEvent = function(marker) {
    var t = this;
    google.maps.event.addListener(marker, 'click', function() {
        window.open(t.href,'_blank');
    });
};

MapRenderer.prototype.setScrollEventListener = function(map) {
    var t = this;


    t.timeout = 0;

    $( window ).scroll(function() {
        map.setOptions({draggable: false});
        window.clearTimeout(t.timeout);

        t.timeout = window.setTimeout(function(){
            map.setOptions({draggable: true});
        },500);

    });
};





// WEBPACK FOOTER //
// ./fe/web-default/src/js/map/renderer.js